import { Group } from '@yarmill/types';
import { axios } from '@yarmill/utils';
import { AxiosPromise } from 'axios';

export function updateGroup(group: Group): AxiosPromise<boolean> {
  return axios.put(`api/UserGroup/${group.UserGroupId}`, group);
}
